import { gql } from '@apollo/client';
import React, { useState } from 'react';
import { SendDocumentsJobContext } from './context';
import { useResettableMutation } from '../../hooks/useResettableMutation';
import { useHistory } from 'react-router-dom';

const START_JOB = gql`
  mutation startSendDocumentsJob(
    $documentRelationshipIds: [ID]!
    $emailAddresses: [String]
    $activeOn: Date
    $includeStakeholders: Boolean
    $policyId: ID
    $clientId: ID
    $insuredId: ID
  ) {
    sendDocumentsEmails(
      documentRelationshipIds: $documentRelationshipIds
      emailAddresses: $emailAddresses
      activeOn: $activeOn
      includeStakeholders: $includeStakeholders
      policyId: $policyId
      clientId: $clientId
      insuredId: $insuredId
    )
  }
`;

export default function SendDocumentsJobProvider({ children }) {
  const history = useHistory();
  const [redirectUrl, setRedirectUrl] = useState(null);
  const [policyId, setPolicyId] = useState(null);
  const [clientId, setClientId] = useState(null);
  const [insuredId, setInsuredId] = useState(null);
  const [emailAddresses, setEmailAddresses] = useState([]);
  const [scheduled, setScheduled] = useState(false);

  const [startDocumentsJob, { loading, error, reset }] = useResettableMutation(START_JOB, {
    onCompleted: () => {
      setScheduled(true);
      history.push(redirectUrl);
    },
    onError: () => setTimeout(() => reset(), 10000)
  });

  const startSendDocumentsJob = ({
    documentRelationshipIds,
    activeOn,
    includeStakeholders,
    redirectUrl,
    clientId,
    policyId,
    insuredId,
    emailAddresses
  }) => {
    setScheduled(false);
    setRedirectUrl(redirectUrl);
    setPolicyId(policyId);
    setClientId(clientId);
    setInsuredId(insuredId);
    setEmailAddresses(emailAddresses);
    startDocumentsJob({
      variables: {
        documentRelationshipIds,
        activeOn,
        includeStakeholders,
        policyId,
        clientId,
        insuredId,
        emailAddresses
      }
    });
  };

  return (
    <SendDocumentsJobContext.Provider
      value={{
        startSendDocumentsJob,
        policyId,
        clientId,
        insuredId,
        emailAddresses,
        loading,
        error,
        scheduled
      }}
    >
      {children}
    </SendDocumentsJobContext.Provider>
  );
}
